function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 14.586L26.293 4.293a1 1 0 1 1 1.414 1.414L17.414 16l10.293 10.293a1 1 0 0 1-1.414 1.414L16 17.414 5.707 27.707a1 1 0 0 1-1.414-1.414L14.586 16 4.293 5.707a1 1 0 0 1 1.414-1.414L16 14.586z"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "0bfc6ecc5c39bc0b510a3abca7c32450.svg";
export { SvgClose as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/close.svg
// module id = null
// module chunks = 